// import debounce from 'lodash/debounce'

class WindowSize {
    constructor() {
        
        this.callbacks = [];
        
        this.width = window.innerWidth
        this.height = window.innerHeight
        
        window.addEventListener('resize', () => {
            this.setSize()
        })
        
        // TODO - Debounce
        // this._setSize = debounce(this.setSize, 200)
        // window.addEventListener('resize', this._setSize)
    }
    
    addListener(callback) {
        this.callbacks.push(callback)
    }
    
    removeListener(callback) {
        for (var i = 0; i < this.callbacks.length; i++) {
            if (callback === this.callbacks[i]) {
                this.callbacks.splice(i, 1)
            }
        }
    }

    setSize() {
        this.width = window.innerWidth
        this.height = window.innerHeight

        // TODO - add total dom height - How to update?
        // this.totalHeight = window.pageYOffset
        
        for (var i = 0; i < this.callbacks.length; i++) {
            this.callbacks[i]()
        }
    }
}

const Size = new WindowSize()
export default Size
